import { EditCompanyCreationRequest } from '@bupa-kkv/features/company-creation/types';
import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';

export const editCompanyCreations = (
  payload: EditCompanyCreationRequest
): Promise<void> => {
  return companyCreationAxiosInstance.patch(
    'v1/customer/companyCreations/edit',
    payload
  );
};
